<label #label [style.width.%]="100" [style.height.px]="15" [style.text-align]="textAlign">{{labelText}}</label>
